import Link from 'next/link'
import Icon from 'components/atomic/Icon'
import { useTrans } from 'hooks'
import React, { useEffect, useState } from 'react'
import { Button } from 'react-components/atoms'
import { sendGTMData } from 'utils/gtm.js'
import { CalendarioAvventoStep1, CalendarioAvventoStep2 } from 'react-components/organisms'
import { api, getGiornoCorrente } from 'utils'
import { CELLECALENDARIO } from 'utils/endpoint'
import { useRouter } from 'next/router'
import { useSelector } from 'react-redux'

api.defaults.xsrfCookieName = 'csrftoken'
api.defaults.xsrfHeaderName = 'X-CSRFTOKEN'

const STEPS = [1, 2]

const CalendarioAvventoTemplate = ({ celleInitial }) => {
  const [step, setStep] = useState(1)
  const [cellaCliccata, setCellaCliccata] = useState(null)

  const [celle, setCelle] = useState(celleInitial ?? [])

  const router = useRouter()
  const t = useTrans()
  const { utente } = useSelector((state) => state.utente)

  useEffect(() => {
    // solo se loggato
    if (utente) {
      const qsStep = Number(router.query?.step)

      // solo se qsStep valido e diverso dal corrente
      if (Boolean(qsStep) && STEPS.includes(qsStep) && step !== qsStep) {
        const giorno = getGiornoCorrente(router)
        const cella = celle.find((c) => c.giorno === giorno)
        if (cella) {
          setCellaCliccata(cella)
          setStep(qsStep)
        }
      }
    }
  }, [router.query?.step, utente])

  useEffect(() => {
    // solo se loggato
    if (utente) {
      const qsGiorno = Number(router.query?.giorno)
      const giornoCorrente = getGiornoCorrente()

      // solo se giorno valido
      if (Boolean(qsGiorno) && qsGiorno <= giornoCorrente) {
        const cella = celle.find((c) => c.giorno === qsGiorno)
        if (cella) {
          setCellaCliccata(cella)
          setStep(2)
        }
      }
    }
  }, [router.query?.giorno, utente])

  useEffect(() => {
    if (cellaCliccata) {
      refreshOnCellaCliccata(cellaCliccata)
    }
  }, [cellaCliccata])

  async function refreshOnCellaCliccata(cella) {
    await api.post(CELLECALENDARIO + 'apri/', { cella: cella.id })
    await refreshCelle()
  }

  const handleGTM = (item) => {
    if (item) {
      sendGTMData({
        event: 'GAevent',
        eventID: '03',
        eventCategory: 'header',
        eventAction: item.toGTMFormat(),
        eventLabel: 'non_valorizzata',
      })
    }
  }

  async function refreshCelle() {
    const response = await api.get(CELLECALENDARIO)
    setCelle(response.data)
  }

  return (
    <div className={`calendario-avvento-template calendario-avvento-template--step-${step}`}>
      <header>
        <div className="header__content_small">
          <Link legacyBehavior href="/">
            <a id="logo" className="header__logo" onClick={() => handleGTM('logo header')}>
              <Icon id="logo-giuntiscuola-color--colored" classes="header__logo-colored" />
            </a>
          </Link>
          <div className="header__side">
            <Button
              href="/"
              label={t('Torna alla home page Giunti Scuola')}
              labelMobile={t('Torna alla home')}
            />
          </div>
        </div>
      </header>
      <div className="w-container-calendario">
        {step === 1 ? (
          <CalendarioAvventoStep1
            celle={celle}
            setStep={setStep}
            cellaCliccata={cellaCliccata}
            setCellaCliccata={setCellaCliccata}
          />
        ) : (
          <CalendarioAvventoStep2
            celle={celle}
            setStep={setStep}
            step={step}
            cellaCliccata={cellaCliccata}
            setCellaCliccata={setCellaCliccata}
            refreshCelle={refreshCelle}
          />
        )}
      </div>
    </div>
  )
}

export default CalendarioAvventoTemplate
